import AppConstants from '../config/app.constants';

let ResetAtmCodeService = function ($http, $q) {

    let getAllKeys = (cacheKey, date) => {
        return $http
            .get(AppConstants.api + `/reset-atm-code/get-all-keys`, {
                params: {
                    cacheKey,
                    date
                }
            })
            .then((res) => {
                return res.data
            })
    };

    let deleteAtmCode = (cacheKey, branchId) => {
        return $http
            .post(AppConstants.api + `/reset-atm-code/delete-atm-codes`, {
                cacheKey,
                branchId
            })
            .then((res) => {
                return res.data
            })
    }

    let getAtmCode = (cacheKey) => {
        return $http
            .get(AppConstants.api + `/reset-atm-code/get-atm-code`, {
                params: {
                    cacheKey
                }
            })
            .then((res) => {
                return res.data
            })
    }

    return {
        getAllKeys,
        deleteAtmCode,
        getAtmCode
    }
};

ResetAtmCodeService.$inject = ['$http', '$q'];

export default ResetAtmCodeService;


// WEBPACK FOOTER //
// ./client/app/services/reset-atm-code.service.js